import { render, staticRenderFns } from "./specific-bigcommerce.vue?vue&type=template&id=db22ca34&"
import script from "./specific-bigcommerce.vue?vue&type=script&lang=js&"
export * from "./specific-bigcommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports